/**
 * This value is used to determine if
 * - workspace drawer should slide in from the right and push panel bank content OR
 * - workspace drawer should be displayed (floating) over the panel bank content with overlay
 */
export const INLINE_DRAWER_MIN_PANEL_BANK_WIDTH = 960;

export const INITIAL_DRAWER_WIDTH = 500;
export const INITIAL_DRAWER_WIDTH_CLASS_NAME = 'w-[500px]';

export const INLINE_WORKSPACE_DRAWER_DURATION = 500; // in ms
export const INLINE_WORKSPACE_DRAWER_DURATION_CLASS_NAME =
  'transition-[width,_opacity] duration-500';
